import produce from 'immer';

import * as actions from './actions';

export const initialState = {
  guardianContactNewsletter: { data: null, loading: false, error: null },
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case (actions.PARSE_NEWSLETTER_TOKEN_REQUEST):
      draft.guardianContactNewsletter.loading = true;
      break;
    case (actions.PARSE_NEWSLETTER_TOKEN_SUCCESS):
      draft.guardianContactNewsletter.loading = false;
      draft.guardianContactNewsletter.data = action.payload.guardianContactNewsletter;
      break;
    case (actions.PARSE_NEWSLETTER_TOKEN_FAILURE):
      draft.guardianContactNewsletter.loading = false;
      draft.guardianContactNewsletter.error = action.payload.error;
      break;
    case (actions.CLEAR_GUARDIAN_CONTACT_NEWSLETTER):
      draft.guardianContactNewsletter = { data: null, loading: false, error: null };
      break;
    default:
  }
});

export default reducer;
